import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

import { Observable, ReplaySubject, switchMap, takeUntil } from "rxjs";

import { withSpinner } from "../../extensions/withSpinner.extension";
import { API_ROOT } from "../../types/constants/appconstants";
import { OrgSelectionService } from "../orgselection.service";
import { UnsubscribeOnDestroy } from "../../classes";

@Injectable({
    providedIn: "root",
})
export class FeatureFlagService extends UnsubscribeOnDestroy {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private orgSelectionService = inject(OrgSelectionService);
    private featureFlagServiceBaseUrl = this.apiRoot + "api/featureFlag";
    public constructionUpdatesEnabledSubject = new ReplaySubject<boolean>();
    public customerPortalTwoWayEnabledSubject = new ReplaySubject<boolean>();

    constructor() {
        super();

        this.constructionUpdatesEnabledSubject.next(false);
        this.customerPortalTwoWayEnabledSubject.next(false);

        this.orgSelectionService.selectedMarket
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                switchMap(mkt => this.getIsConstructionUpdatesEnabled(mkt.orgId))
            )
            .subscribe(enabled => {
                this.constructionUpdatesEnabledSubject.next(enabled)
            });

        this.orgSelectionService.selectedMarket
          .pipe(
            takeUntil(this.ngUnsubscribe$),
            switchMap(mkt => this.getIsCustomerPortalTwoWayEnabled(mkt.orgId))
          )
        .subscribe(enabled => {
          this.customerPortalTwoWayEnabledSubject.next(enabled)
        });

    }

    get constructionUpdatesEnabled(): ReplaySubject<boolean> {
          return this.constructionUpdatesEnabledSubject;
    }
    get customerPortalTwoWayEnabled(): ReplaySubject<boolean> {
        return this.customerPortalTwoWayEnabledSubject;
    }

    private getIsConstructionUpdatesEnabled(marketId: number): Observable<boolean> {
        return withSpinner(this.http).get<boolean>(`${this.featureFlagServiceBaseUrl}/constructionUpdates/${marketId}`)
    }

    private getIsCustomerPortalTwoWayEnabled(marketId: number): Observable<boolean> {
      return withSpinner(this.http).get<boolean>(`${this.featureFlagServiceBaseUrl}/twoWayCommunication/${marketId}`);
    }
}
